/**
 * @ngdoc directive
 * @name mainConfiguration
 * @module portaro.main-configuration
 *
 * @restrict E
 *
 * @param {string} key Key
 * @param {string} value Value.
 * @param {boolean} evaluate If true, `value` is evaluated.
 *
 * @description
 * Directive sets given configuration through {@link service:mainConfigurationService}.
 * If `evaluate` param is `true`, value is evaluated.
 */
export default class MainConfigurationDirective {
    static directiveName = 'mainConfiguration';

    restrict = 'E';
    scope = {
        key: '@',
        value: '@'
    };
    priority = 1000;

    /**
     * @param {mainConfigurationService} mainConfigurationService
     * @param {$parse} $parse
     */

    /*@ngInject*/
    constructor(mainConfigurationService, $parse) {
        this.mainConfigurationService = mainConfigurationService;
        this.$parse = $parse;
    }

    link($scope, $element, attrs) {
        if (attrs && attrs.evaluate === 'true') {
            this.mainConfigurationService.setParameter($scope.key, this.$parse(attrs.value)($scope));
        } else {
            this.mainConfigurationService.setParameter($scope.key, $scope.value);
        }
    }
}
